import React from "react";
import AppBar from "@mui/material/AppBar";
import images from '../assets/images';
import { useNavigate } from "react-router-dom";
import {
  Menu,
  MenuItem,
  Box,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  Toolbar,
  Button,
} from "@mui/material";

const KeyboardArrowRight = React.lazy(
  () => import("@mui/icons-material/KeyboardArrowRight")
);
const ChevronLeftIcon = React.lazy(
  () => import("@mui/icons-material/ChevronLeft")
);
const MenuIcon = React.lazy(() => import("@mui/icons-material/Menu"));
const PhoneIcon = React.lazy(() => import("@mui/icons-material/Phone"));
const EmailIcon = React.lazy(() => import("@mui/icons-material/Email"));
const AccountCircleIcon = React.lazy(
  () => import("@mui/icons-material/AccountCircle")
);

import { RoutePaths } from "../components/Routes";
import AuthStore from "../stores/Auth";
import { UserRoles } from "../models/UserRoles";
import Auth from "../services/Auth";
import RestUtilities from "../services/RestUtilities";
import Users from "../models/Users";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/system";
import { sub } from "date-fns";

const lightColor = "rgba(255, 255, 255, 0.7)";

class Header extends React.Component<{
 // buttonRef: React.createRe<HTMLButtonElement>;
  location: ReturnType<typeof useLocation>;
  navigate: ReturnType<typeof useNavigate>;
  classes: any;
}> {
  state = {
    activeTab: 0,
    adminMenu: false,
    subMenu: false,
    anchorEl: null as any,
    subAnchorEl: null as any,
    userNames: "",
    drawerOpen: false,
  };



  handleClose = () => {
    this.setState({ anchorEl: null, subAnchorEl: null, subMenu: false });
  };

  handleCloseSubmenu = (event: any) => {
    this.setState({ subMenu: false });
  };

  handleNavigate = (event: any) => {
    let url: string =
      event.currentTarget.attributes.getNamedItem("data-url").value;
    this.props.navigate(url);
    this.handleClose();
  };

  openDrawer = () => {
    this.setState({ drawerOpen: true });
  };

  closeDrawer = () => {
    this.setState({ drawerOpen: false });
  };

  navigateToPage = (page: string) => {
    this.props.navigate(page);
  };

  getTabValue = (pathname: string): number => {
    let splitted = pathname.split("/");

    if (splitted[1] == "user") return 0;
    else if (splitted[1] == "admin") return 1;
    else if (pathname == RoutePaths.EditUser) return 2;

    return 0;
  };

  fetchUser = () => {
    let personalNr = window.localStorage.getItem("personalNr");
    if (personalNr == null) return;
    RestUtilities.get<Users>(`/api/register?personalNr=${personalNr}`).then(
      (resp) => {
        let names = `${resp.content.firstname} ${resp.content.lastname}`;
        this.setState({ userNames: names });
      }
    );
  };

  componentDidMount() {
    this.fetchUser();
  }

  handleMenu = (event: any) => {
    let role = event.currentTarget.attributes.getNamedItem("data-role").value;
    let subMenu = false;
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuSub = (event: any) => {
    let role = event.currentTarget.attributes.getNamedItem("data-role").value;
    let subMenu = false;

    if (role === "submenu1" || role === "submenu2") {
      subMenu = !this.state.subMenu;
    }

    this.setState({  subAnchorEl: event.currentTarget, subMenu: subMenu });
  };
  importImage = (imageName:string) => {
      return images[imageName] || null;
  };

  renderMenu = () => {
    const { classes } = this.props;
    const { anchorEl, subAnchorEl } = this.state;
    let menuRole =
      anchorEl !== null
        ? anchorEl.attributes.getNamedItem("data-role").value
        : null;
    let subMenuRole =
      subAnchorEl !== null
        ? subAnchorEl.attributes.getNamedItem("data-role").value
        : null;
    let tabValue = this.getTabValue(this.props.location.pathname);
    return (
      <AppBar
        component="div"
        className={classes.secondaryBar}
        style={{ backgroundColor: "#009be5" }}
        position="static"
        elevation={0}
      >
        <Toolbar> 
          <Button style={{ display: "none" }} value={20} />

          {Auth.isSignedIn() && (
            <> 
              <Button
                className={
                  menuRole === "user" ? "headerTab activeTab" : "headerTab"
                }
                data-role="user"
                aria-owns={open ? "menu-appbar" : undefined}
                aria-haspopup="true"
                onClick={this.handleMenu}
              >
                Persönlich
              </Button>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                open={open && menuRole === "user"}
                onClose={this.handleClose}
              >
                <MenuItem
                  onClick={this.handleNavigate}
                  data-url={RoutePaths.CurrentEvents}
                >
                  Aktuelle Betriebsratsveranstaltungen
                </MenuItem>
                <MenuItem
                  onClick={this.handleNavigate}
                  data-url={RoutePaths.BookedEvents}
                >
                  Gebuchte Veranstaltungen
                </MenuItem>
                <MenuItem
                  onClick={this.handleNavigate}
                  data-url={RoutePaths.PaidEvents}
                >
                  Bezahlte Veranstaltungen
                </MenuItem>
                <MenuItem
                  onClick={this.handleNavigate}
                  data-url={RoutePaths.ChangePassword}
                >
                  Passwort ändern
                </MenuItem>
              </Menu>
 
              {(Auth.isAdmin() ||
                AuthStore.getRole() === UserRoles[UserRoles.Veranstalter]) && (
                <>
                  <Button
                    className={
                      menuRole === "admin" ? "headerTab activeTab" : "headerTab"
                    }
                    data-role="admin"
                    aria-owns={open ? "menu-appbar" : undefined}
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                  >
                    Administrativ
                  </Button>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    open={
                      open &&
                      (menuRole === "admin" ||
                        menuRole === "submenu1" ||
                        menuRole === "submenu2")
                    }
                    onClose={this.handleClose}
                  >
                    <MenuItem
                      data-role="submenu1"
                      data-url="/"
                      onClick={this.handleMenuSub}
                    >
                      Veranstaltungen 
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.Reports}
                      onClick={this.handleNavigate}
                    >
                      Berichte
                    </MenuItem>
                    {Auth.isAdmin() && (
                      <>
                        <MenuItem
                          data-url={RoutePaths.Accounting}
                          onClick={this.handleNavigate}
                        >
                          Abrechnungen
                        </MenuItem>
                        <MenuItem
                          data-role="submenu2"
                          onClick={this.handleMenuSub}
                        >
                          Stammdaten 
                        </MenuItem>
                      </>
                    )}
                    <MenuItem onClick={this.handleClose}>
                      Dokumentation
                    </MenuItem>
                  </Menu>
                  <Menu
                    id="submenu1-appbar"
                    anchorEl={subAnchorEl}
                    
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    open={open && subMenuRole === "submenu1" && this.state.subMenu}
                    onClose={this.handleCloseSubmenu}
                    onMouseLeave={this.handleCloseSubmenu}
                  >
                    <MenuItem
                      data-url={RoutePaths.AdminEvents}
                      onClick={this.handleNavigate}
                    >
                      Veranstaltungen
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.EditEvent}
                      onClick={this.handleNavigate}
                    >
                      Neue Veranstaltung erstellen
                    </MenuItem>
                  </Menu>

                  <Menu
                    id="submenu2-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                    open={open && subMenuRole === "submenu2" && this.state.subMenu}
                    onClose={this.handleCloseSubmenu}
                    onMouseLeave={this.handleCloseSubmenu}
                  >
                    <MenuItem
                      data-url={RoutePaths.AgeGroups}
                      onClick={this.handleNavigate}
                    >
                      Altersklassen
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.MemberGroups}
                      onClick={this.handleNavigate}
                    >
                      Teilnehmergruppen
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.PriceTypes}
                      onClick={this.handleNavigate}
                    >
                      Preistypen
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.EventOptions}
                      onClick={this.handleNavigate}
                    >
                      Veranstaltungsoptionen
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.EventNumbers}
                      onClick={this.handleNavigate}
                    >
                      BMW - Verwaltungsnummern
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.UserData}
                      onClick={this.handleNavigate}
                    >
                      Benutzer
                    </MenuItem>
                    <MenuItem
                      data-url={RoutePaths.UserGroupsPaymentTypes}
                      onClick={this.handleNavigate}
                    >
                      Zahlungsmethoden
                    </MenuItem>
                  </Menu>
                </>
              )}
              <div className="spacer" ></div>
              <Button
                className={
                  menuRole === "profile" ? "headerTab activeTab" : "headerTab"
                }
                onClick={() => this.props.navigate(RoutePaths.EditUser)}
                startIcon={<AccountCircleIcon />}
              >
                <Box sx={{ display: { xs: "none", md: "block" } }}>
                  {this.state.userNames}
                </Box>
              </Button>
              <Button
                className="headerTab"
                onClick={() => {
                  Auth.signOut();
                  window.location.replace(`/`);
                }}
              >
                Logout
              </Button>
            </>
          )}

          {!Auth.isSignedIn() && (
            <Button
              className="headerTab"
              onClick={() => this.props.navigate(RoutePaths.SignIn)}
            >
              Anmelden
            </Button>
          )}
        </Toolbar>
      </AppBar>
    );
  };
  public render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div style={{ marginTop: "10px", marginLeft: "10px" }}>
          <AppBar
            component="div"
            className={classes.secondaryBar}
            style={{ backgroundColor: "white", display: "inline" }}
            position="static"
            elevation={0}
          >
            <div style={{ display: "inline-block", cursor: "pointer" }}>
              <img
                src={this.importImage("bmwgroup-logo.png")} 
                height="32px"
                width="66px"
                onClick={() => this.navigateToPage("/")}
              />
              <p
                style={{
                  fontFamily: '"BMWGroupLight-Regular",helvetica,sans-serif',
                  fontSize: "13px",
                  marginBottom: "0",
                  color: "#000",
                }}
              >
                Werk Steyr
              </p>
            </div>
            <Box sx={{ display: { sm: "inline-block", xs: "none" }, verticalAlign: "top" }}>
              <img src={this.importImage("thenext100years.png")} 
                height="32px"
                width="106px"
                style={{
                  display: "inline-block",
                  verticalAlign: "top",
                  marginLeft: "11px",
                  cursor: "pointer",
                }}
                onClick={() => this.navigateToPage("/")}
              />
            </Box>
            <img src={this.importImage("bmw-logo.png")} 
              height="32px"
              width="33px"
              style={{
                display: "inline-block",
                marginLeft: "40px",
                verticalAlign: "top",
                cursor: "pointer",
              }}
              alt="BMW Logo" onClick={() => this.navigateToPage("/")}/>

            <img
              src={this.importImage("mini-logo.png")} 
              height="32px"
              width="53px"
              style={{
                display: "inline-block",
                marginLeft: "3px",
                verticalAlign: "top",
                cursor: "pointer",
              }}
              onClick={() => this.navigateToPage("/")}
            />
          </AppBar>

          <Box sx={{ display: { xs: "none", lg: "contents" } }}>
            <div className="col-lg-3 col-xl-6 headerInfo">
              <span style={{ display: "inline-block" }}>
                <b>Helpcenter</b> (Mo. bis Do. 8:00 - 16:00 und Fr. 8:00 -
                15:00)
              </span>
              <br />
              <span>
                <PhoneIcon />
                072528882153
              </span>
              <span>
                <EmailIcon
                  style={{ marginLeft: "2rem", marginRight: "0.5rem" }}
                />
                arbeiterbetriebsrat@list.bmw.com
              </span>
            </div>
          </Box>

          <div
            style={{
              float: "right",
              display: "inline-flex",
              marginRight: "17px",
              position: "relative",
            }}
          >
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Link to="/impressum" className="header-link ">
                IMPRESSUM
              </Link>
              <span className="header-separator">|</span>
              <a
                href="../Teilnahmebedingungen_für_Veranstaltungen_des_BMW_Betriebsrates.pdf"
                target="_blank"
                className="header-link "
              >
                TEILNAHMEBEDINGUNGEN
              </a>{" "}
              <span className="header-separator">|</span>
              <a
                href="../Datenschutzerklärung_für_das_Anmeldesystem.pdf"
                target="_blank"
                className="header-link "
              >
                DATENSCHUTZ
              </a>
            </Box>
            <Box sx={{ display: { xs: "block", md: "none" } }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={() => this.openDrawer()}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </div>
          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="right"
            open={this.state.drawerOpen}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={() => this.closeDrawer()}>
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <List>

                <ListItemButton key={"IMPRESSUM"}>
                  <a href={ "/impressum"} target="_blank">
                    {"IMPRESSUM"}
                  </a>
                </ListItemButton>
                 <ListItemButton key={"TEILNAHMEBEDINGUNGEN"}>
                  <a href="./Teilnahmebedingungen_für_Veranstaltungen_des_BMW_Betriebsrates.pdf" target="_blank">
                    {"TEILNAHMEBEDINGUNGEN"}
                  </a>
                </ListItemButton>
                 <ListItemButton key={"DATENSCHUTZ"}>
                  <a href="/.Datenschutzerklärung_für_das_Anmeldesystem.pdf" target="_blank">
                    {"DATENSCHUTZ"}
                  </a>
                </ListItemButton>
              
            </List>
          </Drawer>
        </div>
        {this.renderMenu()}
      </React.Fragment>
    );
  }
}

//export default withStyles(styles)(Header);
export default styled(Header)(({ theme }) => ({
  secondaryBar: {
    zIndex: 0,
  },
  iconButtonAvatar: {
    padding: 4,
  },
  link: {
    textDecoration: "none",
    color: lightColor,
    "&:hover": {
      color: theme.palette.common.white,
    },
  },
  button: {
    borderColor: lightColor,
  },
}));
